import NextVideoCard from "../NextVideoCard/NextVideoCard";
import "./NextVideoList.scss";
function NextVideoList({videoLink, videoList, selectedVideoId }) {
  return (
    <div className="playlist">
      <p className="label-btn playlist__title">Next Videos</p>
{/* component takes next videos playlist data filters out the selected video playing on the main video section and creates a list of rest of the videos in the playlist */}
      {videoList
        .filter((video) => video.id !== selectedVideoId)
        .map((video) => {
          return (
            <NextVideoCard
              key={video.id}
              id={video.id}
              img={videoLink+video.image}
              title={video.title}
              channel={video.channel}
            />
          );
        })}
    </div>
  );
}

export default NextVideoList;
